import axios from "axios";
import { EndpointConfig } from "../config";

const axiosI = axios.create({
    baseURL: EndpointConfig.apiUrl,
});

axiosI.interceptors.request.use((config) => {
    const token = localStorage.getItem("token")
    if(token){
        config.headers.Authorization =  `Bearer ${JSON.parse(token)}`;
    }
    return config;
}, (error) => {
    // Handle the error
    return Promise.reject(error);
});

axiosI.interceptors.response.use(config => {
    return config;
}, error => {
    console.dir(error);
    if (error.response.status === 401) {
        alert('Session Timeout');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});

export const axiosInstance = axiosI;